<template>
  <div class="sa-rep-table-wrap">
    <table class="sa-rep-table">
      <thead>
        <tr>
          <th scope="col" class="is-id">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'id')">
              ID <span aria-hidden="true">{{ sortMark('id') }}</span>
            </button>
          </th>
          <th scope="col" class="is-company">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'name')">
              Empresa <span aria-hidden="true">{{ sortMark('name') }}</span>
            </button>
          </th>
          <th scope="col">Sistema</th>
          <th scope="col">Tipo</th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'courses')">
              Cursos <span aria-hidden="true">{{ sortMark('courses') }}</span>
            </button>
          </th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'sales')">
              Vendas <span aria-hidden="true">{{ sortMark('sales') }}</span>
            </button>
          </th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'avgTicket')">
              Ticket médio <span aria-hidden="true">{{ sortMark('avgTicket') }}</span>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="'cs-' + row.id">
          <td class="is-id">{{ row.id }}</td>
          <td class="is-company"><span class="sa-rep-table__name">{{ row.name }}</span></td>
          <td><SystemBadge :type-system="row.typeSystem" /></td>
          <td><CompanyTypeBadge :row="row" /></td>
          <td class="is-num">{{ formatNumberBR(row.courses) }}</td>
          <td class="is-num">{{ formatNumberBR(row.sales) }}</td>
          <td class="is-num">{{ formatCurrencyBRL(row.avgTicket) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SystemBadge from './SystemBadge.vue';
import CompanyTypeBadge from './CompanyTypeBadge.vue';
import { formatCurrencyBRL, formatNumberBR } from '@/utils/superAdmin/formatters';

export default {
  name: 'SalesReportTable',
  components: { SystemBadge, CompanyTypeBadge },
  props: {
    rows: { type: Array, default: () => [] },
    sortKey: { type: String, default: 'sales' },
    sortDir: { type: String, default: 'desc' },
  },
  emits: ['sort'],
  methods: {
    formatNumberBR,
    formatCurrencyBRL,
    sortMark(key) {
      if (this.sortKey !== key) return '↕';
      return this.sortDir === 'asc' ? '↑' : '↓';
    },
  },
};
</script>

<style src="./report-table.css"></style>
